<template>
  <div id="ag-grid-lists">
    <div id="div-with-loading" class="vs-con-loading__container">
      <vs-tabs class="agreement-req-list custom-vs-tabs request-page slot-border-top">
        <vs-tab label="New Requests">
          <div class="tab-text">
            <AgreementRequestsComponent></AgreementRequestsComponent>
          </div>
        </vs-tab>

        <vs-tab label="Edit Requests">
          <div class="tab-text">
            <AgreementRequestsComponent editReq></AgreementRequestsComponent>
          </div>
        </vs-tab>
      </vs-tabs>
    </div>
  </div>
</template>

<script>
import AgreementRequestsComponent from "@/components/ag-grid-tables/agreements/AgreementRequestsComponent.vue";

export default {
  components: {
    AgreementRequestsComponent
  },
   data() {
    return {
      newReqFlag:0,
    }
  },
  watch:{
    newReqFlag(val) {
      if(val == 2){
        document.querySelectorAll('.vs-collapse-item--header').forEach(item => item.click());
      }
    }
  },
  methods: {
    incNewReqFlag(){
      this.newReqFlag++;
      // console.log('newReqFlag', this.newReqFlag);
    }
  }
};
</script>